import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class User implements ViewModel {
  readonly friendlyTypeNameSingular = 'User';
  readonly apiRoute: string = CONFIG.apiRoutes.user;

  public userID: string;
  public firstName: string;
  public surname: string;
  public username: string;
  public password: string;
  public passwordInputValue: string;
  public verifyPassword: string;
  public passwordResetRequired: boolean;
  public email: string;
  public lastLoggedIn: Date;
  public lastLoggedOut: Date;
  public catalog: string;
  public isDefaultAdmin: boolean;
  public imageData: any;
  public sanitizedImageData: any;
  public userRoles: any[] = [];
  public loginProvider: string;
  /**
   * @depracated - isSecurity property should be removed from User class
   * */
  public isSecurity: boolean;
  public activeDirectoryId: string;
  public fullName: string;
  public isRolesChanged: boolean;

  public externalUserId: string;

  public json(): this {
    return this;
  }

  public loadFromJson(data: Partial<this>): void {
    this.userID = data.userID;
    this.username = data.username;
    this.password = data.password;
    this.passwordResetRequired = data.passwordResetRequired;
    this.firstName = data.firstName;
    this.surname = data.surname;
    this.email = data.email;
    this.lastLoggedIn = data.lastLoggedIn;
    this.lastLoggedOut = data.lastLoggedOut;
    this.isDefaultAdmin = data.isDefaultAdmin;
    this.catalog = data.catalog;
    this.loginProvider = data.loginProvider;
    this.externalUserId = data.externalUserId;
    this.isSecurity = data.isSecurity;
    this.userRoles = data.userRoles;
    this.activeDirectoryId = data.activeDirectoryId;
    this.fullName = `${this.firstName || ''} ${this.surname || ''}`;
  }

  // API uses a NULL value for user.loginProvider to signify a local accout. The login provider dropdown control uses a
  // local string value which gets nulled on save, so check for both to determine a local login provider
  get isLocalUser(): boolean {
    return !this.loginProvider || this.loginProvider === 'local';
  }
}
